<!--申请退款信息-->
<template>
  <div class="apply-info-container">
    <el-form :model="applyInfo" status-icon :rules="applyRules" ref="applyInfo" class="applyForm" label-position="top"
             hide-required-asterisk>
      <el-form-item prop="reason" label="退款原因">
        <el-select v-model="applyInfo.reason" placeholder="请选择" style="width: 40%" clearable>
          <el-option v-for="item in reasonList" :label="item.reasonname" :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item prop="money" label="退款金额">
        <el-input :placeholder="'最大为￥'+parseFloat(data.price).toFixed(2)+''" v-model="applyInfo.money" readonly
                  style="width: 40%"/>
      </el-form-item>
      <el-form-item label="退款说明">
        <el-input type="textarea" :rows="5" style="width: 40%" placeholder="补充退款说明，提高退款成功率"
                  v-model="applyInfo.explain"/>
      </el-form-item>
      <!--上传凭证最多三张-->
      <el-form-item>
        <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="3"
                   ref="upload"
                   list-type="picture-card" :file-list="voucher" :on-exceed="handleExceed" :multiple="true"
                   :on-success="successUpload" accept=".png,.jpeg,.jpg" :on-preview="handlePictureCardPreview"
                   :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="submitForm('applyInfo')">提交</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>
<script>
import {getRefundReason, applicationForRefund} from '@/api/orderApi'

export default {
  name: "applyInfo",
  data() {
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入退款金额！'));
      }
      if (value <= this.data.price) {
        callback();
      } else {
        callback(new Error('最大为￥' + parseFloat(this.data.price).toFixed(2)));
      }
    }
    return {
      applyInfo: {
        reason: '',
        explain: '',
        money: null,
        voucher: [],
        id: 0,
      },
      applyRules: {
        money: [
          {validator: checkMoney, trigger: 'blur'}
        ],
        reason: {required: true, trigger: 'change', message: '请选择退款原因!'},
      },
      voucher: [],
      maxMoney: 0,
      reasonList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      cid: 0,
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    state: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    /*提交申请*/
    submitForm(formName) {
      if (this.applyInfo.money == '') {
        this.applyInfo.money = this.data.price;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          applicationForRefund({
            aftermarketType: 0,
            cid: this.cid,
            image: this.applyInfo.voucher.join(','),
            money: this.applyInfo.money,
            order_id: this.$route.query.id,
            reason: this.applyInfo.explain,
            refund_id: this.applyInfo.reason,
            uid: this.cid
          }).then(res => {
            if (res.code == 200) {
              this.$message.success('退款申请已提交！');
              this.$emit('goback');
            } else {
              this.$message.error('申请提交失败！');
            }
          })
        } else {
          return false;
        }
      });
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /*检索上传数量，限制上传3张*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*上传凭证成功处理*/
    successUpload(response, file, fileList) {
      this.applyInfo.voucher.push(response.imgPath);
    },
    /*删除上传凭证*/
    handleRemove(file, fileList) {
      for (let i in this.applyInfo.voucher) {
        if (this.applyInfo.voucher[i] == file.response.imgPath) {
          this.applyInfo.voucher.splice(i, 1)
        }
      }
    },
    /*获取退款原因列表*/
    getRefundReasonList() {
      getRefundReason().then(res => {
        if (res.code == 200) {
          this.reasonList = res.data;

        }
      })
    }
  },
  mounted() {
    this.getRefundReasonList();
  },
  watch:{
    data: function (val, oldVal) {
      if (val.state == '-2') {
        this.$set(this.applyInfo, 'money', val.returnMoney);
        this.applyInfo.id = val.return_id;
        this.applyInfo.explain = val.reason;
        if (val.voucherImage.indexOf(',') > -1) {
          let voucher = val.voucherImage.split(',');
          for (let v of voucher) {
            this.applyInfo.voucher.push(v)
            this.voucher.push({name:v,url:v})
          }
        }else{
          this.applyInfo.voucher.push(val.voucherImage)
          this.voucher.push({name:val.voucherImage,url:val.voucherImage})
        }
        for (let list of this.reasonList){
          if (list.reasonname==val.refund)
            this.applyInfo.reason=list.id;
        }
      }else{
        this.applyInfo.money=val.price;
      }
    }
  },
  beforeMount() {
    this.cid = JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>
<style scoped>
.apply-info-container >>> .el-form-item__label {
  font-size: 16px;
  color: #333333;
  line-height: 40px;
  padding: 0 0 0px;
  font-weight: 100;
  font-family: SourceHanSansCN;
}

.apply-info-container >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 40px;
}

.apply-info-container >>> .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.apply-info-container >>> input::-webkit-input-placeholder {
  color: #999999;
}

.apply-info-container >>> textarea ::-webkit-input-placeholder {
  color: #999999;
}
</style>
<style scoped lang="scss">
.apply-info-container {

}
</style>